import styled from "styled-components";

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  margin-top: 16px;
  margin-bottom: 24px;
  gap: 0;
`;

export const TitleSection = styled.div`
  color: ${(props) => props.theme.colors.darkGray};
`;
